import type {
  FetchAffiliateOrderFilteredSearchOptionsResponse,
  FetchAffiliateOrderRefundListRequest,
  FetchAffiliateOrderRefundListResponse,
  FetchAffiliateOrderRefundOptionsRequest,
  FetchAffiliateOrderRefundOptionsResponse,
  FetchWebShopOrderFilterOptionsResponse,
  RequestWalttiPosOrderRefundResponse,
  WalttiPosOrderRefundRequest
} from 'Services/SalesManagement/Features/Order/types'
import { createBaseApi } from 'Util/ApiClient'

export const orderApi = createBaseApi({
  reducerPath: 'orderApi',
  keepUnusedDataFor: 10,
  tagTypes: []
}).injectEndpoints({
  endpoints: builder => ({
    getWebShopOrderFilterOptions: builder.query<FetchWebShopOrderFilterOptionsResponse, void>({
      query: () => ({
        url: '/api/v1/web-orders/',
        method: 'OPTIONS'
      })
    }),
    getMobileOrderFilteredSearchOptions: builder.query<
      FetchAffiliateOrderFilteredSearchOptionsResponse,
      void
    >({
      query: () => ({
        url: '/api/v1/affiliate-orders/mobile/',
        method: 'OPTIONS'
      })
    }),
    getWalttiPosOrderFilteredSearchOptions: builder.query<
      FetchAffiliateOrderFilteredSearchOptionsResponse,
      void
    >({
      query: () => ({
        url: '/api/v1/affiliate-orders/register-walttipos/',
        method: 'OPTIONS'
      })
    }),
    getMobileOrderRefundOptions: builder.query<
      FetchAffiliateOrderRefundOptionsResponse,
      FetchAffiliateOrderRefundOptionsRequest
    >({
      query: ({ id }) => ({
        url: `/api/v1/affiliate-orders/mobile/${id}/refund/`,
        method: 'OPTIONS'
      })
    }),
    getWalttiPosOrderRefundOptions: builder.query<
      FetchAffiliateOrderRefundOptionsResponse,
      FetchAffiliateOrderRefundOptionsRequest
    >({
      query: ({ id }) => ({
        url: `/api/v1/affiliate-orders/register-walttipos/${id}/refund/`,
        method: 'OPTIONS'
      })
    }),
    getMobileOrderRefundList: builder.query<
      FetchAffiliateOrderRefundListResponse,
      FetchAffiliateOrderRefundListRequest
    >({
      query: ({ id }) => ({
        url: `/api/v1/affiliate-orders/mobile/${id}/refund/`,
        method: 'GET'
      })
    }),
    getWalttiPosOrderRefundList: builder.query<
      FetchAffiliateOrderRefundListResponse,
      FetchAffiliateOrderRefundListRequest
    >({
      query: ({ id }) => ({
        url: `/api/v1/affiliate-orders/register-walttipos/${id}/refund/`,
        method: 'GET'
      })
    }),
    requestWalttiPosOrderRefund: builder.mutation<
      RequestWalttiPosOrderRefundResponse,
      WalttiPosOrderRefundRequest
    >({
      query: ({ id, ...data }) => ({
        url: `/api/v1/affiliate-orders/register-walttipos/${id}/refund/`,
        method: 'POST',
        body: data
      })
    })
  })
})

export const {
  useGetWebShopOrderFilterOptionsQuery,
  useGetMobileOrderFilteredSearchOptionsQuery,
  useGetWalttiPosOrderFilteredSearchOptionsQuery,
  useGetMobileOrderRefundOptionsQuery,
  useGetWalttiPosOrderRefundOptionsQuery,
  useGetMobileOrderRefundListQuery,
  useGetWalttiPosOrderRefundListQuery,
  useRequestWalttiPosOrderRefundMutation
} = orderApi
